import { type CellRendererProps, Text } from '@innovationdepartment/proxima-ui';
import type { BrandProductMetricAttributes } from 'types/brandProducts';
import BrandProductsAveragePrice from './Layout/BrandProducts.CellRender.AveragePrice';
import BrandProductsClassificationScore from './Layout/BrandProducts.CellRender.ClassificationScore';
import BrandProductsItemsPurchased from './Layout/BrandProducts.CellRender.ItemsPurchased';
import BrandProductsRevenuePercentage from './Layout/BrandProducts.CellRender.RevenuePercentage';
import BrandProductsTitle from './Layout/BrandProducts.CellRender.Title';
import BrandProductsTotalRevenue from './Layout/BrandProducts.CellRender.TotalRevenue';

/* here only goes additional props */
type AdditionalProps = object;
const cellRenderer = (props: CellRendererProps<BrandProductMetricAttributes> & AdditionalProps) => {
  const { header, cell, row } = props;

  if (header === 'averagePriceUsd') return <BrandProductsAveragePrice value={cell as string} />;

  if (header === 'totalRevenueUsd') return <BrandProductsTotalRevenue value={cell as string} />;

  if (header === 'itemsPurchased') return <BrandProductsItemsPurchased value={cell as string} />;

  if (header === 'classificationScore')
    return <BrandProductsClassificationScore value={cell as number} />;

  if (header === 'revenuePercentage')
    return <BrandProductsRevenuePercentage value={cell as string} />;

  if (header === 'title') return <BrandProductsTitle value={cell as string} row={row} />;

  return <Text>{cell as string}</Text>;
};

export default cellRenderer;
